import { ShieldCheck, TrendingUp } from "lucide-react";
import { player } from "../data/sample";
import { ScoreRing } from "./primitives";

/** Cinematic in-app screen shown inside the hero phone. Pure markup — no images. */
export function PhoneMockup({ className = "" }: { className?: string }) {
  const stats = [
    { label: "Verified coach reports", value: player.verifiedReports },
    { label: "Videos", value: player.videos },
    { label: "Seasons", value: player.seasons },
  ];
  return (
    <div
      className={`relative w-[268px] sm:w-[300px] ${className}`}
      style={{ filter: "drop-shadow(0 40px 80px rgba(0,0,0,0.55))" }}
    >
      <div className="rounded-[2.4rem] border border-line/80 bg-elevated p-2.5 ring-soft">
        <div className="relative overflow-hidden rounded-[1.9rem] border border-line/60 bg-background">
          {/* notch */}
          <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-black/60" />
          <div className="bg-field-grid">
            <div className="space-y-4 bg-gradient-to-b from-background/40 via-background/80 to-background p-5 pt-9">
              {/* header */}
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2.5">
                  <img
                    src={player.photo}
                    alt={player.name}
                    className="h-11 w-11 rounded-xl object-cover ring-1 ring-white/15"
                  />
                  <div>
                    <p className="text-[10px] uppercase tracking-wider text-ink-muted">{player.club}</p>
                    <p className="text-sm font-bold leading-tight">{player.name}</p>
                    <p className="text-[10px] text-ink-soft">
                      {player.age} · {player.position}
                    </p>
                  </div>
                </div>
                <span className="inline-flex items-center gap-1 rounded-full border border-green/40 bg-green/10 px-2 py-1 text-[10px] font-semibold text-green">
                  <ShieldCheck className="h-3 w-3" /> Parent
                </span>
              </div>

              {/* score + velocity */}
              <div className="flex items-center gap-3 rounded-2xl border border-line/70 bg-surface/80 p-3">
                <ScoreRing value={player.score} size={104} stroke={9} />
                <div className="flex-1">
                  <div className="flex items-center gap-1.5 text-green">
                    <TrendingUp className="h-4 w-4" />
                    <span className="text-lg font-extrabold">+{player.velocity}%</span>
                  </div>
                  <p className="text-[11px] leading-tight text-ink-muted">
                    Development Velocity over the last 6 months
                  </p>
                </div>
              </div>

              {/* stat row */}
              <div className="grid grid-cols-3 gap-2">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-xl border border-line/60 bg-elevated/60 p-2.5 text-center">
                    <p className="text-lg font-extrabold leading-none text-ink">{s.value}</p>
                    <p className="mt-1 text-[9px] leading-tight text-ink-muted">{s.label}</p>
                  </div>
                ))}
              </div>

              {/* next action */}
              <div className="rounded-xl border border-blue/30 bg-blue/5 p-3">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-blue">Next focus</p>
                <p className="mt-1 text-[11px] leading-snug text-ink-soft">
                  Off-ball movement and first-touch consistency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
